import { IdType } from "../Utils/IdType";

export const objectWithIdNotFoundMessage = (id: IdType, objectName: string) =>
  `An error occurred when retrieving the ${objectName} with the Id ${id}`;

export const updateFailedMessage = (id: IdType, objectName: string) =>
  `An error occurred when updating the ${objectName} with Id ${id}`;

export const deleteFailedMessage = (id: IdType, objectName: string) =>
  `An error occurred when deleting the ${objectName} with Id ${id}`;
